module.exports = __webpack_public_path__ + "img/uswitch-logo.324b36a9.png";